import axios from 'axios';
import {
    TIPS_URL
} from 'constants/api';

export const getEngagementSurveyTips = (engagementSurveyToken) => {
    const URL = `${ process.env.API_URL }${ TIPS_URL }${ engagementSurveyToken }`;
    return axios.get(URL)
        .then(res => {
            return res;
        })
        .catch(err => {
            throw err;
        });
};
